import React, { useCallback, useState } from "react";
import PersonalData from "./PersonalData";
import FormPageHeader from "../utilities/FormPageHeader";
import { Box } from "@mui/system";
import { Button, Checkbox, Chip, FormControlLabel, FormGroup, Grid, Stack, Switch, TextField, Tooltip, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import moment from "moment";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useEffect } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import { DateTimePicker, TimePicker } from "@mui/x-date-pickers";

const LeaveManagementForm = () => {

    const params = useParams();
    const navigate = useNavigate();
    const [leaveTypeOptions, setLeaveTypeOptions] = useState([])
    const [empTypeOptions, setEmpTypeOptions] = useState([]);
    const [successMsg, setSuccessMsg] = useState();
    const [snackState, setSnackState] = useState(false);
    const [currentEmp, setCurrentEmp] = useState();
    const [error, setError] = useState();
    const [fromError, setFromError] = useState();
    const [toError, setToError] = useState();
    const [worktype, setWorktype] = useState()
    const [saveDisable, setSaveDisable] = useState(true);
    const [day, setDay] = useState('Full Day')
    const [dayOptions, setDayOptions] = useState([
        { label: "Full Day", value: "Full Day" },
        { label: "Half Day", value: "Half Day" }
    ])
    const [planningOptions, setPlanningOptions] = useState([
        { label: "Plan", value: "PLAN" },
        { label: "Used", value: "USED" }
    ]);
    const [editLeave, setEditLeave] = useState()
    const [additionalLeaveData, setAdditionalLeaveData] = useState([])
    const [leaveData, setLeaveData] = useState({
        leaveCategory: '',
        workType: '',
        leaveGroup: '',
        leavePlan: '',
        leaveStatus: 'WAITING',
        isEmergency: false,
        isShortNotice: false,
        from: '',
        to: '',
        reason: '',
        address: '',
        contactDetail: '',
        halfDay: false,
        halfDayDate: '',
        email: false,
        usedays: ''
    });
    const LeaveUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leave}`;
    const LeaveinfoesUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveInfoes}`;
    const leaveEntitlements = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveEntitlements}`;

    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));

    const getEditLeave = async () => {
        let id = params.id
        try {
            const listData = await OAuthService.getList(LeaveinfoesUrl + `/${id}`);
            if (listData?.data) {
                setCurrentEmp(listData?.data?.employee)
                setLeaveData({
                    ...leaveData,
                    leaveCategory: listData?.data?.leaveType?.leaveCategory?.category,
                    workType: listData?.data?.workType,
                    leaveGroup: listData?.data?.leaveGroup,
                    leavePlan: listData?.data?.leavePlan,
                    leaveApprvlStatus: listData?.data?.leaveApprvlStatus,
                    isEmergency: listData?.data?.isEmergency,
                    isShortNotice: listData?.data?.isShortNotice,
                    from: listData?.data?.fromDate,
                    to: listData?.data?.toDate,
                    halfDay: listData?.data?.halfDay,
                    halfDayDate: listData?.data?.halfDayDate,
                    reason: listData?.data?.reason,
                    address: listData?.data?.address,
                    contactDetail: listData?.data?.contactDetail,
                })
                setEditLeave({
                    ...leaveData,
                    leaveCategory: listData?.data?.leaveType?.leaveCategory?.category,
                    workType: listData?.data?.workType,
                    leaveGroup: listData?.data?.leaveGroup,
                    leavePlan: listData?.data?.leavePlan,
                    isEmergency: listData?.data?.isEmergency,
                    isShortNotice: listData?.data?.isShortNotice,
                    leaveApprvlStatus: listData?.data?.leaveApprvlStatus,
                    from: listData?.data?.from,
                    to: listData?.data?.to,
                    halfDay: listData?.data?.halfDay,
                    halfDayDate: listData?.data?.halfDayDate,
                    reason: listData?.data?.reason,
                    address: listData?.data?.address,
                    contactDetail: listData?.data?.contactDetail,
                });

                if (listData?.data?.halfDay) {
                    setDay('Half Day')
                }
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }

    const loadEntitleDays = async () => {
        if (currentEmp?.employeeId) {
            const list = await OAuthService.getList(leaveEntitlements + `/search/findByEmployeeId?employeeId=${currentEmp?.employeeId}`);
            if (list?.data) {
                setLeaveData({ ...leaveData, maximumday: list?.data?.entitleNoOfdays, alloweddays: list?.data?.remainingLeaves, usedays: list?.data?.leavesTaken })
            }
        }
    }
    useEffect(() => {
        if (params.id) {
            getEditLeave()
        }
    }, [])

    useEffect(() => {
        loadEntitleDays();
    }, [currentEmp, editLeave])
console.log(currentEmp,"currentEmp");
    const handleSubmit = async () => {

        let year = new Date(leaveData.from).getFullYear() || new Date(leaveData.halfDayDate).getFullYear();
        let model = {
            empId: currentEmp?.employeeId,
            country: currentEmp?.currentAddress?.country,
            year: year,
            ...leaveData,
        }
        delete model.usedays;
        delete model.alloweddays;
        delete model.maximumday;
        try {
            if (params.id) {
                let id = params.id
                model = { ...model, leaveInfoId: id }
                await OAuthService.addData(LeaveUrl + '/editApplyLeave', model);
                setSuccessMsg("Leave Data Updateed Successfully");
                setSnackState(true)
                setTimeout(() => { navigate('/LeaveManagement') }, 800);
            } else {
                let entitleMentID = await OAuthService.getList(leaveEntitlements + `/search/findByEmployeeId?employeeId=${currentEmp?.employeeId}`)
                if (entitleMentID?.data) {
                    await OAuthService.addData(LeaveUrl + '/applyLeave', model);
                    if (additionalLeaveData.length > 0) {
                        await Promise.all(additionalLeaveData.map(async (data) => {
                            let year = new Date(data.from).getFullYear() || new Date(data.halfDayDate).getFullYear();
                            if ((data.from && data.to) || data.halfDayDate) {
                                const jsonBody = {
                                    ...leaveData,
                                    empId: currentEmp?.employeeId,
                                    country: currentEmp?.currentAddress?.country,
                                    year: year,
                                    from: data.from,
                                    to: data.to,
                                    halfDay: data.halfDay,
                                    halfDayDate: data.halfDayDate,
                                }

                                delete jsonBody.usedays;
                                delete jsonBody.alloweddays;
                                delete jsonBody.maximumday;

                                await OAuthService.addData(LeaveUrl + '/applyLeave', jsonBody);
                            }
                        }))
                    }
                    setSuccessMsg("Leave Data saved Successfully");
                    setSnackState(true)
                    setTimeout(() => { navigate('/LeaveManagement') }, 800);
                }
                else {
                    let leaveEntitlementID = await OAuthService.getList(LeaveUrl + `/saveDefaultLeaveEntitleOfEmpForAYear?year=${year}&empId=${currentEmp?.employeeId}&empName=${currentEmp?.displayName}`)
                    if (leaveEntitlementID?.data) {
                        await OAuthService.addData(LeaveUrl + '/applyLeave', model);
                        if (additionalLeaveData.length > 0) {
                            await Promise.all(additionalLeaveData.map(async (data) => {
                                let year = new Date(data.from).getFullYear() || new Date(data.halfDayDate).getFullYear();
                                if ((data.from && data.to) || data.halfDayDate) {
                                    const jsonBody = {
                                        ...leaveData,
                                        empId: currentEmp?.employeeId,
                                        country: currentEmp?.currentAddress?.country,
                                        year: year,
                                        from: data.from,
                                        to: data.to,
                                        halfDay: data.halfDay,
                                        halfDayDate: data.halfDayDate,
                                    }

                                    delete jsonBody.usedays;
                                    delete jsonBody.alloweddays;
                                    delete jsonBody.maximumday;
                                    await OAuthService.addData(LeaveUrl + '/applyLeave', jsonBody);
                                }
                            }))
                        }
                        setSuccessMsg("Leave Data saved Successfully");
                        setSnackState(true)
                        setTimeout(() => { navigate('/LeaveManagement') }, 800);
                    }
                }
            }
        }
        catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const handleCancel = () => {
        navigate('/LeaveManagement');
    }

    const handleLeaveType = (data) => {
        setLeaveData({ ...leaveData, leaveCategory: data.value })
    }

    const handleLeaveStatus = (data) => {
        setLeaveData({ ...leaveData, leavestatus: data.value })
    }

    const handleLeavePlanning = (data) => {
        setLeaveData({ ...leaveData, leavePlan: data.value })
    }

    const handleChangeEmpType = (data) => {
        setLeaveData({ ...leaveData, workType: data.value })
    }

    const handleApprove = (event) => {

    }

    const handleReject = (event) => {

    }

    const handleFromDateChange = async (value) => {
        const startDate = value === null ? null : value;
        let obj = { ...leaveData, from: startDate }
        if (value) {
            obj = { ...obj, to: null }
        }
        if (day === 'Half Day') {
            obj = { ...obj, halfDayDate: value }
        } else {
            obj = { ...obj, halfDayDate: '' }
        }
        setLeaveData(obj);
    }

    const handleLeaveButton = () => {
        setAdditionalLeaveData([...additionalLeaveData, { ...leaveData, dayopt: 'Full Day' }]);
    }

    const handleLeaveChange = (index, value, name) => {
        const leaves = [...additionalLeaveData];
        if (leaves[index].dayopt === 'Half Day') {
            leaves[index].halfDay = true;
            leaves[index].halfDayDate = leaves[index].from;
        } else {
            leaves[index].halfDay = false;
            leaves[index].halfDayDate = '';
        }
        leaves[index][name] = value;
        setAdditionalLeaveData(leaves);
    }

    const deleteLeaveButton = (index) => {
        const additionalLeaves = additionalLeaveData.filter((data, key) => { if (key !== index) { return data; } })
        setAdditionalLeaveData(additionalLeaves)
    }

    const handleToDateChange = async (value) => {
        const endDate = value === null ? null : value;
        setLeaveData({ ...leaveData, to: endDate });
        (!leaveData.from && endDate) ? setFromError('Please select from date ') : setFromError('');

    }

    const handleChangeDay = (value) => {
        if (value.value === 'Half Day') {
            setLeaveData({ ...leaveData, halfDay: true });
        } else {
            setLeaveData({ ...leaveData, halfDay: false });
        }
        setDay(value.value)
    }

    useEffect(() => {
        const loadAllLeaveType = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveCategories}`;
            try {
                const list = await OAuthService.getList(url);
                if (list?.data) {
                    const allCat = list?.data?._embedded?.leaveCategories.map((data) => {
                        return { label: data.category, value: data.category }
                    })
                    setLeaveTypeOptions(allCat)
                }

            } catch (error) {

            }
        }
        loadAllLeaveType();

        const workType = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employementTypes}`;
            try {
                const list = await OAuthService.getList(url + '?size=1000');
                if (list?.data) {
                    const allCat = list?.data?._embedded?.employementTypes.map((data) => {
                        return { label: data.name, value: data.name }
                    })
                    setEmpTypeOptions(allCat)
                }

            } catch (error) {

            }
        }
        workType();

        const getCurrentEmployee = async () => {
            if (!params.id) {
                const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
                const email = token?.email;

                const emp = await OAuthService.getList(url + `/search/findEmployeeByEmail?email=${email}`);
                setCurrentEmp(emp?.data)
                setLeaveData({...leaveData , address : emp?.data?.currentAddress?.address1,  contactDetail : emp?.data?.currentAddress?.mobile , workType :emp?.data?.employementType?.name})
            }
        }
        getCurrentEmployee();

    }, [])
    
    useEffect(() => {
        if (leaveData?.leaveCategory && leaveData?.leavePlan && leaveData?.from && leaveData?.to && leaveData?.reason && leaveData?.email) {
            if (leaveData?.leaveCategory !== editLeave?.leaveCategory ||leaveData?.leaveGroup !== editLeave?.leaveGroup || leaveData?.isEmergency !== editLeave?.isEmergency
                || leaveData?.isShortNotice !== editLeave?.isShortNotice|| leaveData?.leavePlan !== editLeave?.leavePlan || leaveData?.from !== editLeave?.from || leaveData?.to !== editLeave?.to
                || leaveData?.reason !== editLeave?.reason ||leaveData?.email !== editLeave?.email ) {
                setSaveDisable(false);
            } 
            else{
                setSaveDisable(true)
            }
        } else {
            setSaveDisable(true)
        }
    }, [leaveData])

    const LeaveInputField = () => {
        return (
            <>
                {((params.id) && (token?.scope?.includes("ROLE_MD") || token?.scope?.includes("ROLE_HR"))) ?
                    <>
                        <Chip sx={{ color: '#FFA726' }} label={editLeave?.leaveApprvlStatus} className="flex self-center " />
                        <Tooltip title={"Approve Leave"}>
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={handleApprove}
                            >
                                <FuseSvgIcon>heroicons-outline:check-circle</FuseSvgIcon>
                            </Button>
                        </Tooltip>

                        <Tooltip title={"Reject Leave"}>
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={handleReject}
                            >
                                <FuseSvgIcon>material-solid:block</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                    </>
                    : (
                        <Tooltip title={"Save Leave"}>
                            <Button
                                type="submit"
                                onClick={handleSubmit}
                                variant="contained"
                                color="warning"
                                className="mx-auto"
                                disabled={saveDisable}

                            >
                                <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                    )
                }

                <Tooltip title={"Cancel"}>
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        color="warning"
                        className="mx-auto"
                    >
                        <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                    </Button>
                </Tooltip>
            </>
        )
    }

    const handleHalfDateChange = (value) => {
        setLeaveData({ ...leaveData, halfDayDate: value, halfDay: true })
    }

    return (
        <>
            <FormPageHeader
                currentPage={params?.id ? 'Edit Leave' : "Add Leave"}
                componentName={"LeaveManagement"}
                headerInputFields={LeaveInputField()}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                saveDisable={saveDisable}
            />
            <Box sx={{ width: '100%' }}>
                <Grid container spacing={3}>
                    <Grid xs={2} className="mt-24">
                        <PersonalData email={token?.email} mobile={currentEmp?.mobile} />
                    </Grid>
                    <Grid xs={5} className="mt-24">
                        <Box className="m-5" sx={{ p: 3, border: '1px dashed grey' }}>
                            <Typography className="text-[#ffa726] text-lg mt-5" >Leave Properties</Typography>
                            <Stack className="mt-14">
                                <label className=" basis-0 float-left">Leave Type</label>
                                <Select
                                    name="leavetype"
                                    value={(leaveData.leaveCategory && leaveTypeOptions.length > 0) && leaveTypeOptions.filter((data) => data.value === leaveData.leaveCategory)}
                                    onChange={handleLeaveType}
                                    options={leaveTypeOptions}
                                    styles={customStyles()}
                                >
                                </Select>
                            </Stack>
                            <Stack className="mt-14">
                                <label className=" basis-0 float-left">Employeement Type</label>
                                <Select
                                    name="worktype"
                                    value={(empTypeOptions.length > 0 && leaveData.workType) && empTypeOptions.filter((data) => data.value === leaveData.workType)}
                                    onChange={handleChangeEmpType}
                                    options={empTypeOptions}
                                    styles={customStyles()}
                                >
                                </Select>
                            </Stack>
                            <Stack className="mt-14">
                                <label className=" basis-0 float-left">Maximum Day</label>
                                <TextField
                                    className="w-[100%]"
                                    name='max_day'
                                    value={leaveData.maximumday}
                                    onChange={(e) => setLeaveData({ ...leaveData, maximumday: e.target.value })}
                                    disabled
                                />
                            </Stack>
                            {/* <Stack className="mt-14">
                                <label className=" basis-0 float-left">Leave Group</label>
                                <TextField
                                    className="w-[100%]"
                                    name='leave_group'
                                    value={leaveData.leaveGroup}
                                    onChange={(e) => setLeaveData({ ...leaveData, leaveGroup: e.target.value })}
                                />
                            </Stack> */}
                        </Box>
                    </Grid>
                    <Grid xs={5} className="mt-24">
                        <Box className="m-5" sx={{ p: 3, border: '1px dashed grey' }}>
                            <Typography className="text-[#ffa726] text-lg mt-5" >Leave Status</Typography>
                            <Stack className="mt-14">
                                <label className=" basis-0 float-left">Planning</label>
                                <Select
                                    name="planning"
                                    value={(planningOptions.length > 0 && leaveData.leavePlan) && planningOptions.filter((data) => data.value === leaveData.leavePlan)}
                                    options={planningOptions}
                                    onChange={handleLeavePlanning}
                                    styles={customStyles()}
                                >
                                </Select>
                            </Stack>
                            <Stack className="mt-14">
                                <label className=" basis-0 float-left">Leave Group</label>
                                <TextField
                                    className="w-[100%]"
                                    name='leave_group'
                                    value={leaveData.leaveGroup}
                                    onChange={(e) => setLeaveData({ ...leaveData, leaveGroup: e.target.value })}
                                />
                            </Stack>
                            {/* <Stack className="mt-14">
                                <label className=" basis-0 float-left">Status</label>
                                <Select
                                    name="status"
                                    value={(leaveStatusOptions.length > 0 && leaveData.leaveStatus) && leaveStatusOptions.filter((data) => data.value === leaveData.leaveStatus)}
                                    options={leaveStatusOptions}
                                    onChange={handleLeaveStatus}
                                    styles={customStyles()}
                                >
                                </Select>
                            </Stack> */}
                            <FormGroup aria-label="position" row className="mt-14 p-5">
                                <FormControlLabel
                                    value="start"
                                    control={<Switch checked={leaveData.isEmergency}
                                        onChange={(e) => setLeaveData({ ...leaveData, isEmergency: e.target.checked })} />}
                                    label="Is Emergency Leave"
                                />
                                <FormControlLabel
                                    value="start"
                                    control={<Switch checked={leaveData.isShortNotice}
                                        onChange={(e) => setLeaveData({ ...leaveData, isShortNotice: e.target.checked })} />}
                                    label="Is Short Notice Leave"
                                />
                            </FormGroup>
                            {/* <Stack className="mt-14">
                                    <label>Is Emergency Leave</label>
                                    <Switch checked={leaveData.isEmergency}
                                        onChange={(e) => setLeaveData({ ...leaveData, isEmergency: e.target.checked })} />
                                    <label>Is Short Notice Leave</label>
                                    <Switch checked={leaveData.isShortNotice}
                                        onChange={(e) => setLeaveData({ ...leaveData, isShortNotice: e.target.checked })} />
                                </Stack> */}
                        </Box>
                    </Grid>
                </Grid>
                <Grid>
                    <Box className="m-5" sx={{ p: 3, border: '1px dashed grey' }}>

                        <Typography className="text-[#ffa726] text-lg mt-5" >Leave Duration</Typography>


                        <Box className="m-5" sx={{ p: 3, border: '1px dashed grey' }}>
                            <Grid container >
                                <Grid item xs={6}>
                                    <Stack >
                                        <label className=" basis-0 float-left">Status</label>
                                        <Select
                                            name="status"
                                            value={(dayOptions.length > 0 && day) && dayOptions.filter((data) => data.value === day)}
                                            options={dayOptions}
                                            onChange={handleChangeDay}
                                            styles={customStyles()}
                                        >
                                        </Select>
                                    </Stack>

                                </Grid>
                                <Grid item xs={6}>

                                </Grid>
                            </Grid>

                            {day === 'Half Day' &&
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <div className="mt-12">
                                            <label className=" basis-0 ">From:</label>
                                            <Stack className="">
                                                <DateTimePicker
                                                    className="w-[100%]"
                                                    name={'from'}
                                                    value={leaveData.from}

                                                    onChange={handleFromDateChange}
                                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                    }} {...params} sx={{

                                                    }} />}
                                                />
                                                <p className="text-red">{(fromError && !leaveData.from) && fromError}</p>
                                            </Stack>
                                        </div>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Stack className="mt-12">
                                            <label className=" basis-0 float-left">Week Days</label>
                                            <TextField
                                                className="w-[100%]"
                                                name='week_days'
                                                value={leaveData.from && new Date(leaveData.from).getDay()}
                                                disabled

                                            />
                                        </Stack>
                                    </Grid>


                                    <Grid item xs={6}>
                                        <div className="mt-5">
                                            <label className=" basis-0 ">To:</label>
                                            <Stack className="">
                                                <DateTimePicker
                                                    className="w-[100%]"
                                                    name={'to'}
                                                    value={leaveData.to}
                                                    minDate={new Date(leaveData.from)}
                                                    maxDate={new Date(leaveData.from)}

                                                    onChange={handleToDateChange}
                                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                    }} {...params} sx={{

                                                    }} />}
                                                />
                                                <p className="text-red">{(toError && !leaveData.to) && toError}</p>
                                            </Stack>
                                        </div>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Stack className="mt-12">
                                            <label className=" basis-0 float-left">Week Days</label>
                                            <TextField
                                                className="w-[100%]"
                                                name='week_days'
                                                value={leaveData.to && new Date(leaveData.to).getDay()}
                                                disabled

                                            />
                                        </Stack>
                                    </Grid>

                                </Grid>
                            }
                            {day === 'Full Day' &&
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <div className="mt-12">
                                            <label className=" basis-0 ">From:</label>
                                            <Stack className="">
                                                <CustomDatePicker
                                                    className="w-[100%]"
                                                    format={'dd-MM-yyyy'}
                                                    name={'from'}
                                                    value={leaveData.from}

                                                    handleChange={handleFromDateChange}
                                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                    }} {...params} sx={{
                                                        backgroundColor: props.viewData && '#8080800f',
                                                    }} />}
                                                />
                                                <p className="text-red">{(fromError && !leaveData.from) && fromError}</p>
                                            </Stack>
                                        </div>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Stack className="mt-12">
                                            <label className=" basis-0 float-left">Week Days</label>
                                            <TextField
                                                className="w-[100%]"
                                                name='week_days'
                                                value={leaveData.from && new Date(leaveData.from).getDay()}
                                                disabled

                                            />
                                        </Stack>
                                    </Grid>


                                    <Grid item xs={6}>
                                        <div className="mt-5">
                                            <label className=" basis-0 ">To:</label>
                                            <Stack className="">
                                                <CustomDatePicker
                                                    className="w-[100%]"
                                                    format={'dd-MM-yyyy'}
                                                    name={'to'}
                                                    value={leaveData.to}
                                                    minDate={new Date(leaveData.from)}

                                                    handleChange={handleToDateChange}
                                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                    }} {...params} sx={{
                                                        backgroundColor: props.viewData && '#8080800f'
                                                    }} />}
                                                />
                                                <p className="text-red">{(toError && !leaveData.to) && toError}</p>
                                            </Stack>
                                        </div>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Stack className="mt-12">
                                            <label className=" basis-0 float-left">Week Days</label>
                                            <TextField
                                                className="w-[100%]"
                                                name='week_days'
                                                value={leaveData.to && new Date(leaveData.to).getDay()}
                                                disabled

                                            />
                                        </Stack>
                                    </Grid>

                                </Grid>
                            }
                        </Box>
                        {additionalLeaveData.length > 0 && additionalLeaveData.map((data, index) => {
                            return (
                                <Box className="m-5" sx={{ p: 3, border: '1px dashed grey' }}>
                                    <Grid container >
                                        <Grid item xs={6}>
                                            <Stack >
                                                <label className=" basis-0 float-left">Status</label>
                                                <Select
                                                    name="status"
                                                    value={(dayOptions.length > 0 && data.dayopt) && dayOptions.filter((d) => d.value === data.dayopt)}
                                                    options={dayOptions}
                                                    onChange={(value) => {
                                                        handleLeaveChange(index, value.value, 'dayopt')
                                                    }}
                                                    styles={customStyles()}
                                                >
                                                </Select>
                                            </Stack>

                                        </Grid>
                                        <Grid item xs={6} className="">
                                        <div className="flex justify-end">
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                onClick={(e) => {
                                                    deleteLeaveButton(index)
                                                }}
                                            >
                                                <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                                            </Button>
                                            </div>
                                        </Grid>
                                    </Grid>

                                    {data.dayopt === 'Half Day' &&
                                        <Grid container spacing={3}>
                                            <Grid item xs={6}>
                                                <div className="mt-12">
                                                    <label className=" basis-0 ">From:</label>
                                                    <Stack className="">
                                                        <DateTimePicker
                                                            className="w-[100%]"
                                                            name={'from'}
                                                            value={data.from}
                                                            onChange={(val) => handleLeaveChange(index, val, 'from')}
                                                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                            }} {...params} sx={{

                                                            }} />}
                                                        />
                                                    </Stack>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Stack className="mt-12">
                                                    <label className=" basis-0 float-left">Week Days</label>
                                                    <TextField
                                                        className="w-[100%]"
                                                        name='week_days'
                                                        value={data.from && new Date(data.from).getDay()}
                                                        disabled
                                                    />
                                                </Stack>
                                            </Grid>


                                            <Grid item xs={6}>
                                                <div className="mt-5">
                                                    <label className=" basis-0 ">To:</label>
                                                    <Stack className="">
                                                        <DateTimePicker
                                                            className="w-[100%]"
                                                            name={'to'}
                                                            value={data.to}
                                                            minDate={new Date(data.from)}
                                                            maxDate={new Date(data.from)}
                                                            onChange={(val) => handleLeaveChange(index, val, 'to')}
                                                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                            }} {...params} sx={{
                                                            }} />}
                                                        />
                                                    </Stack>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Stack className="mt-12">
                                                    <label className=" basis-0 float-left">Week Days</label>
                                                    <TextField
                                                        className="w-[100%]"
                                                        name='week_days'
                                                        value={data.to && new Date(data.to).getDay()}
                                                        disabled
                                                    />
                                                </Stack>
                                            </Grid>

                                        </Grid>
                                    }
                                    {data.dayopt === 'Full Day' &&
                                        <Grid container spacing={3}>
                                            <Grid item xs={6}>
                                                <div className="mt-12">
                                                    <label className=" basis-0 ">From:</label>
                                                    <Stack className="">
                                                        <CustomDatePicker
                                                            className="w-[100%]"
                                                            format={'dd-MM-yyyy'}
                                                            name={'from'}
                                                            value={data.from}
                                                            handleChange={(val) => handleLeaveChange(index, val, 'from')}
                                                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                            }} {...params} sx={{
                                                                backgroundColor: props.viewData && '#8080800f',
                                                            }} />}
                                                        />
                                                        <p className="text-red">{(fromError && !leaveData.from) && fromError}</p>
                                                    </Stack>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Stack className="mt-12">
                                                    <label className=" basis-0 float-left">Week Days</label>
                                                    <TextField
                                                        className="w-[100%]"
                                                        name='week_days'
                                                        value={data.from && new Date(data.from).getDay()}
                                                        disabled
                                                    />
                                                </Stack>
                                            </Grid>


                                            <Grid item xs={6}>
                                                <div className="mt-5">
                                                    <label className=" basis-0 ">To:</label>
                                                    <Stack className="">
                                                        <CustomDatePicker
                                                            className="w-[100%]"
                                                            format={'dd-MM-yyyy'}
                                                            name={'to'}
                                                            value={data.to}
                                                            minDate={new Date(data.from)}
                                                            handleChange={(val) => handleLeaveChange(index, val, 'to')}
                                                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                                                            }} {...params} sx={{
                                                                backgroundColor: props.viewData && '#8080800f'
                                                            }} />}
                                                        />
                                                    </Stack>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Stack className="mt-12">
                                                    <label className=" basis-0 float-left">Week Days</label>
                                                    <TextField
                                                        className="w-[100%]"
                                                        name='week_days'
                                                        value={data.to && new Date(data.to).getDay()}
                                                        disabled

                                                    />
                                                </Stack>
                                            </Grid>

                                        </Grid>
                                    }
                                </Box>
                            )
                        })}
                         {!params.id && <div className="flex justify-end"> <Tooltip title={"Add Other Leave"} >
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px", marginTop: "10px" }}
                                onClick={handleLeaveButton}
                            >
                                <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                            </Button>
                        </Tooltip >
                        </div>}
                        < Grid container spacing={3}>
                            <Grid item xs={6}>
                                <Stack className="mt-5">
                                    <label className=" basis-0 float-left">Allowed Days</label>
                                    <TextField
                                        className="w-[100%]"
                                        name='allowed_days'
                                        value={leaveData.alloweddays}
                                        onChange={(e) => setLeaveData({ ...leaveData, alloweddays: e.target.value })}
                                        disabled
                                    />
                                </Stack>
                            </Grid>

                            <Grid item xs={6}>
                                <Stack className="mt-5">
                                    <label className=" basis-0 float-left">Used Days</label>
                                    <TextField
                                        className="w-[100%]"
                                        name='used_days'
                                        value={leaveData.usedays}
                                        onChange={(e) => setLeaveData({ ...leaveData, usedays: e.target.value })}
                                        disabled
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                {(!token?.scope?.includes("ROLE_MD") || !token?.scope?.includes("ROLE_HR")) &&
                    <Grid container className="block">
                        <Box className="m-5" sx={{ p: 3, border: '1px dashed grey' }}>
                            <Typography className="text-[#ffa726] text-lg mt-5" >Description & Addresses</Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <Stack className="mt-12">
                                        <label className=" basis-0 float-left">Leave Reason</label>
                                        <TextField
                                            className="w-[100%]"
                                            name='leave_reason'
                                            value={leaveData.reason}
                                            onChange={(e) => setLeaveData({ ...leaveData, reason: e.target.value })}
                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={6}>
                                    <Stack className="mt-12">
                                        <label className=" basis-0 float-left">Contact Details</label>
                                        <TextField
                                            className="w-[100%]"
                                            name='contact'
                                            value={leaveData.contactDetail}
                                            onChange={(e) => setLeaveData({ ...leaveData, contactDetail: e.target.value })}
                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={6}>
                                    <Stack className="mt-5">
                                        <label className=" basis-0 float-left">Address</label>
                                        <TextField
                                            className="w-[100%]"
                                            name='address'
                                            value={leaveData.address}
                                            onChange={(e) => setLeaveData({ ...leaveData, address: e.target.value })}
                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={6}>
                                    <Stack className="mt-24">
                                        {/* <label className=" basis-0 float-left">Email add during leave</label> */}
                                        {/* <TextField
                                            className="w-[100%]"
                                            name='email_leave'
                                            value={leaveData.emailduringleave}
                                            onChange={(e) => setLeaveData({ ...leaveData, emailduringleave: e.target.value })}
                                        /> */}
                                        <FormControlLabel control={<Checkbox />} checked={leaveData?.email} value={leaveData?.email} onChange={(e) => setLeaveData({ ...leaveData, email: e.target.checked })} label="Email add during leave" />
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                }
            </Box>

        </>
    )
}
export default LeaveManagementForm